/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ContentEditableEvent } from 'react-contenteditable';
import { EditableField, FieldType, ITextEditProps } from './editable-fields/editable-field';

export { ContentEditableEvent };

export interface ITextProps {
    tag?: string;
    text?: string;
    className?: string;
    editProps?: ITextEditProps;
}
// eslint-disable-next-line jsdoc/require-jsdoc
export class Text extends React.Component<ITextProps> {
    constructor(props: ITextProps) {
        super(props);
        this.state = { html: props.text };
    }

    public render = (): JSX.Element => {
        return (
            <EditableField
                onChange={this.props.editProps ? this.props.editProps.onEdit : this.onEdit} // handle innerHTML change
                requestContext={this.props.editProps?.requestContext}
                fieldProps={{
                    text: this.props.text,
                    tag: this.props.tag,
                    className: this.props.className
                }}
                type={FieldType.Text}
            />
        );
    };

    private onEdit = (event: ContentEditableEvent) => null;
}
